import React from 'react';
import { Provider } from 'react-redux';

import BadgeItem from './BadgeItem';
import { FeatureList, BadgesContainer } from './styles';
import { FeatureModalView } from '../../../../Roofing/Shingles/Index';
import { useFeatures } from '../../../../Roofing/Shingles/features';
import { store } from '../../../../Store';

const PerformanceBadges = shingle => {
  const features = useFeatures();
  const [featureSelected, setFeatureSelected] = React.useState();

  if (!features || features.length === 0) {
    return null;
  }

  return (
    <Provider store={store}>
      <BadgesContainer>
        <FeatureList>
          {features
            .filter(feature => !feature.excludeFromFeaturesList && feature.isInShingleOrColor(shingle.shingle))
            .map(feature => (
              <BadgeItem
                key={feature.key}
                name={feature.name}
                analyticsOption={feature.analyticsOption}
                icon={feature.icon}
                alt={feature.alt}
                onClick={() => setFeatureSelected(feature)}
              />
            ))}
        </FeatureList>
      </BadgesContainer>
      <FeatureModalView feature={featureSelected} onClose={() => setFeatureSelected(null)} />
    </Provider>
  );
};

export default PerformanceBadges;
